import { Controller } from "@hotwired/stimulus"

// Pflegegrad-Selbsttest: 6 Fragen (eine je NBA-Modul), 4 Antwortstufen.
//
// Grobe clientseitige Schätzung, keine echte NBA-Begutachtung. Je Modul
// fließt der Anteil (0/1/2/3 von 3) mit dem Modul-Gewicht in die Summe ein.
// Modul 2 und 3 bilden zusammen einen 15-Punkte-Slot — wie im echten NBA
// (§ 15 SGB XI) zählt nur der höhere der beiden Werte, sonst käme man über
// 100 Punkte maximal möglich.
const GEWICHTE = { 1: 10, 4: 40, 5: 20, 6: 15 }
const MODULE = [1, 2, 3, 4, 5, 6]

const BAENDER = [
  { max: 12.5, label: "Nach dieser Schätzung: aktuell kein Pflegegrad absehbar" },
  { max: 27, label: "Nach dieser Schätzung: möglicherweise Pflegegrad 1" },
  { max: 47.5, label: "Nach dieser Schätzung: möglicherweise Pflegegrad 2" },
  { max: 70, label: "Nach dieser Schätzung: möglicherweise Pflegegrad 3" },
  { max: 90, label: "Nach dieser Schätzung: möglicherweise Pflegegrad 4" },
  { max: Infinity, label: "Nach dieser Schätzung: möglicherweise Pflegegrad 5" }
]

export default class extends Controller {
  static targets = ["answerButton", "punkte", "ergebnis"]

  initialize() {
    this.antworten = Object.fromEntries(MODULE.map((m) => [m, 0]))
  }

  connect() {
    this.render()
  }

  select(event) {
    const modul = parseInt(event.currentTarget.dataset.modul)
    const wert = parseInt(event.currentTarget.dataset.value)
    this.antworten[modul] = wert
    this.render()
  }

  render() {
    MODULE.forEach((modul) => {
      const buttons = this.answerButtonTargets.filter((btn) => parseInt(btn.dataset.modul) === modul)
      buttons.forEach((btn) => {
        const on = parseInt(btn.dataset.value) === this.antworten[modul]
        btn.classList.toggle("border-ph24_new_blue", on)
        btn.classList.toggle("bg-ph24_new_blue/5", on)
        btn.classList.toggle("text-ph24_new_blue", on)
        btn.classList.toggle("border-gray-200", !on)
        btn.setAttribute("aria-pressed", on ? "true" : "false")
      })
    })

    const anteil = (modul) => this.antworten[modul] / 3
    const punkte =
      anteil(1) * GEWICHTE[1] +
      Math.max(anteil(2), anteil(3)) * 15 +
      anteil(4) * GEWICHTE[4] +
      anteil(5) * GEWICHTE[5] +
      anteil(6) * GEWICHTE[6]

    this.punkteTarget.textContent = Math.round(punkte * 10) / 10
    this.ergebnisTarget.textContent = BAENDER.find((b) => punkte < b.max).label
  }
}
